
A comparison of three tablets that each represent a different philosophy on what a digital writing surface should be.
